export const PageFilter = function (q = '', page = 0, size = 5000, sortDirection = 'ASC', sortColumn = 'fullName', reviewProcessId = '', statusFilterOptions = []) {
    this.q                   = q;
    this.page                = page;
    this.size                = size;
    this.sortColumn          = sortColumn;
    this.sortDirection       = sortDirection;
    this.reviewProcessId     = reviewProcessId;
    this.statusFilterOptions = statusFilterOptions;
};
